export type StaffRole = 'owner' | 'site_manager' | 'worker';

export interface StaffPermissions {
  appointments: {
    viewAllBusiness?: boolean; // owner/site manager
    viewAssignedOnly?: boolean; // worker
    manage?: boolean; // confirm/cancel/reschedule/assign
    updateStatus?: boolean; // mark complete, etc.
  };
  locations?: {
    manage?: boolean;
  };
  workers?: {
    manage?: boolean;
  };
  services?: {
    manage?: boolean;
  };
  billing?: {
    manage?: boolean;
  };
}

export interface StaffMembership {
  id: string; // businessId (or membershipId)
  userId: string;
  businessId: string;
  role: StaffRole;
  permissions: StaffPermissions;
  locationIds?: string[];
  workerId?: string;
  status: 'active' | 'revoked';
  createdAt: string;
  updatedAt: string;
}

export interface StaffInvite {
  id: string;
  businessId: string;
  invitedByUserId: string;
  email?: string;
  phone?: string;
  emailLower?: string;
  role: StaffRole;
  permissions: StaffPermissions;
  locationIds?: string[];
  workerId?: string;
  token: string;
  status: 'pending' | 'accepted' | 'revoked' | 'expired';
  createdAt: string;
  acceptedAt?: string;
  acceptedByUserId?: string;
}

export function permissionsForRole(role: StaffRole): StaffPermissions {
  switch (role) {
    case 'owner':
      return {
        appointments: { viewAllBusiness: true, manage: true, updateStatus: true },
        locations: { manage: true },
        workers: { manage: true },
        services: { manage: true },
        billing: { manage: true },
      };
    case 'site_manager':
      return {
        appointments: { viewAllBusiness: true, manage: true, updateStatus: true },
        locations: { manage: true },
        workers: { manage: true },
        services: { manage: false },
        billing: { manage: false },
      };
    case 'worker':
    default:
      return {
        appointments: { viewAssignedOnly: true, manage: false, updateStatus: true },
        locations: { manage: false },
        workers: { manage: false },
        services: { manage: false },
        billing: { manage: false },
      };
  }
}

